import { TradeFairState } from '@/api/tradeFairs'

/**
 * Written out rather than built as `tradeFairs.state.${state}`: the catalogue keys are typed, so a
 * state without a translation fails the build instead of rendering its key.
 */
export const STATE_LABEL_KEYS = {
  [TradeFairState.UPCOMING]: 'tradeFairs.state.UPCOMING',
  [TradeFairState.RUNNING]: 'tradeFairs.state.RUNNING',
  [TradeFairState.PAST]: 'tradeFairs.state.PAST',
} as const

export const STATE_HINT_KEYS = {
  [TradeFairState.UPCOMING]: 'tradeFairs.stateHint.UPCOMING',
  [TradeFairState.RUNNING]: 'tradeFairs.stateHint.RUNNING',
  [TradeFairState.PAST]: 'tradeFairs.stateHint.PAST',
} as const

/** The order the filter offers them in: what is happening now, then what is next, then history. */
export const FILTERABLE_STATES = [
  TradeFairState.RUNNING,
  TradeFairState.UPCOMING,
  TradeFairState.PAST,
] as const
